import { g as __rest, b as __assign } from '../../../../_tslib-7a01aab4.js';
import React from 'react';

var ListItemBoxHeader = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (React.createElement("div", __assign({ className: 'list-item-history-title' }, rest), children));
};

export { ListItemBoxHeader };
